<template>
  <sui-page>
    <sui-page-header
      :pageId="this.$options.name"
    />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_EPNO')"
              :vertical="false"
              optional
            />
          </div>
          <div class="col-xs-3">
            <sui-text-field
              v-model="epNo"
              @keyup.enter="onSearch"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_EMPL_NM')"
              :vertical="false"
              optional
            />
          </div>
          <div class="col-xs-3">
            <sui-text-field
              v-model="emplName"
              @keyup.enter="onSearch"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_CPNY_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-text-field
              v-model="companyName"
              @keyup.enter="onSearch"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_DEPT_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-text-field
              v-model="deptName"
              @keyup.enter="onSearch"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_IRSD_STT')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-code-select
              ref="irsdStatus"
              :selected="selectedCode.COD_IRSD_STT"
              :customOpitonList="selCodes.allOption"
              codeId="COD_IRSD_STT"
              :initialSelectedIndex="0"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_ACC_AVAIL')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-yn-select
              ref="accAvail"
              :selected="selectedCode.ynAccAvail"
              :initialSelectedIndex="0"
              :customOpitonList="selCodes.allOption"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_USE_YN')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-yn-select
              ref="useSel"
              :selected="selectedCode.ynUseSel"
              :initialSelectedIndex="0"
              :customOpitonList="selCodes.allOption"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_ACC_STATUS')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-code-select
              ref="selectACO"
              :selected="selectedCode.COD_USR_ACO_STT"
              :pageId="$options.name"
              codeId="COD_USR_ACO_STT"
              :customOpitonList="selCodes.allOption"
              :initialSelectedIndex="0"
            />
          </div>
        </div>
        <div class="btn_wrap">
          <sui-button
            type="button"
            class="comm_btn_Reset"
            @click="onReset"
          >
            {{ $t('MSG_BTN_RESET') }}
          </sui-button>
          <sui-button
            v-permission:read="'PGE_CMY_00009'"
            type="button"
            class="comm_btn_Scr"
            @click="onSearch"
          >
            {{ $t('MSG_BTN_SEARCH') }}
          </sui-button>
        </div>
      </div>
      <div class="mrB30" />
      <sui-grid
        ref="grdList"
        :showCountControl="true"
        :showDisplayCountControl="true"
        :initialPagesize="10"
        :columns="gridColumns"
        :dataset="'dsData'"
      >
        <div class="btn_wrapR">
          <sui-button
            v-permission:download="'PGE_CMY_00009'"
            type="button"
            class="comm_btn_gridTop comm_ico_excel"
            @click="onExcelDownload"
          >
            {{ $t('MSG_BTN_EXCEL_DOWN') }}
          </sui-button>
        </div>
      </sui-grid>
      <div class="comm_btn_wrap">
        <sui-button
          v-permission:update="'PGE_CMY_00009'"
          type="button"
          class="comm_btn_border"
          @click="onClickAuthCopy"
        >
          {{ $t('MSG_BTN_AUTH_COPY') }}
        </sui-button>
        <sui-button
          type="button"
          class="comm_btn_border"
          @click="onClickAuthDetail"
        >
          {{ $t('MSG_BTN_AUTH_SRCH') }}
        </sui-button>
        <sui-button
          v-permission:create="'PGE_CMY_00009'"
          type="button"
          class="comm_btn_solid"
          @click="onItemAdd"
        >
          {{ $t('MSG_BTN_USR_RGST') }}
        </sui-button>
      </div>
    </sui-page-contents>
  </sui-page>
</template>
<script>
export default {
  name: 'PGE_CMY_00009', // eslint-disable-line vue/name-property-casing
  data() {
    return {
      userComboDisable: false,
      selCodes: CommonConstants.selectOptions(),
      knoxPlaceHolder: '',
      knoxId: '',
      epNoPlaceHolder: '',
      epNo: '',
      emplNamePlaceHolder: '',
      emplName: '',
      companyNamePlaceHolder: '',
      companyName: '',
      deptNamePlaceHolder: '',
      deptName: '',
      selectedCode: {
        COD_IRSD_STT: { label: '', key: '' },
        ynAccAvail: { label: '', key: '' },
        ynUseSel: { label: '', key: '' },
        COD_USR_ACO_STT: { key: '', label: '' },
      },
      localdata: [],
      gridColumns: [
      {
        text: this.$t('MSG_TXT_EPNO'),
        datafield: 'epno',
        width: 80,
      }, {
        text: this.$t('MSG_TXT_EMPL_NM'),
        datafield: 'usrNameList',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellButtonList(row, column, value, htmlElement, {
            handler: this.onUserRegist,
          }, this.dsData, this.$refs.grdList);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
        width: 120,
      }, {
        text: this.$t('MSG_TXT_EMPL_NM_GLBL'),
        datafield: 'usrGlobalNameList',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellButtonList(row, column, value, htmlElement, {
            handler: this.onUserRegist,
          }, this.dsData, this.$refs.grdList);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
        width: 150,
      }, {
        text: this.$t('MSG_TXT_CRLV'),
        datafield: 'crlvNm',
        width: 100,
      }, {
        text: this.$t('MSG_TXT_CPNY_NM'),
        datafield: 'cpnyNm',
        // width: 200,
      }, {
        text: this.$t('MSG_TXT_DEPT_NM'),
        datafield: 'deptNm',
        // width: 200,
      }, {
        text: this.$t('MSG_TXT_COMP_CONTACT'),
        datafield: 'companyContactAddr',
        width: 120,
      }, {
        text: this.$t('MSG_TXT_IRSD_STT'),
        datafield: 'irsdSttNm',
        width: 100,
      }, {
        text: this.$t('MSG_TXT_ACC_AVAIL'),
        datafield: 'accountUseYn',
        // createwidget: (row, column, value, htmlElement) => {
        //   utils.getGridCellFactory().createCellButton(row, column, value, htmlElement, {
        //     handler: this.onGridSingleButtonClicked,
        //     type: 'link',
        //     checkEditableFunction: this.checkEditableFunction,
        //   }, this.dsData, this.$refs.grdList);
        // },
        // initwidget(row, column, value, htmlElement) {
        //   utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        // },
        width: 100,
      }, {
        text: this.$t('MSG_TXT_ACC_STATUS'),
        datafield: 'usrAccountStatusNm',
        width: 90,
      }, {
        text: this.$t('MSG_TXT_USE_YN'),
        datafield: 'usrRealUseYnNm',
        width: 90,
      }],
    };
  },
  computed: {},
  watch: {
  },
  datasets: [{
    id: 'dsData',
    type: 'local',
    data: 'localdata',
    datafields: [
      { name: 'no', type: 'int', map: 'no' },
      { name: 'userId', type: 'string', map: 'userId' },
      { name: 'epid', type: 'string', map: 'epid' },
      { name: 'knoxId', type: 'string', map: 'knoxId' },
      { name: 'epno', type: 'string', map: 'epno' },
      { name: 'usrNm', type: 'string', map: 'usrNm' },
      { name: 'usrGlblNm', type: 'string', map: 'usrGlblNm' },
      { name: 'hraSiteCd', type: 'string', map: 'hraSiteCd' },
      { name: 'cpnyCd', type: 'string', map: 'cpnyCd' },
      { name: 'cpnyNm', type: 'string', map: 'cpnyNm' },
      { name: 'companyContactAddr', type: 'string', map: 'companyContactAddr' },
      { name: 'deptId', type: 'string', map: 'deptId' },
      { name: 'deptNm', type: 'string', map: 'deptNm' },
      { name: 'crlvCd', type: 'string', map: 'crlvCd' },
      { name: 'crlvNm', type: 'string', map: 'crlvNm' },
      { name: 'irsdSttCd', type: 'string', map: 'irsdSttCd' },
      { name: 'irsdSttNm', type: 'string', map: 'irsdSttNm' },
      { name: 'usrRealUseYn', type: 'string', map: 'usrRealUseYn' },
      { name: 'usrRealUseYnNm', type: 'string', map: 'usrRealUseYnNm' },
      { name: 'accAvail', type: 'string', map: 'accAvail' },
      { name: 'accountUseYn', type: 'string', map: 'accountUseYn' },
      { name: 'usrNameList', type: 'object', map: 'usrNameList' },
      { name: 'usrGlobalNameList', type: 'object', map: 'usrGlobalNameList' },
      { name: 'usrAccountStatusNm', type: 'string', map: 'usrAccountStatusNm' },
    ],
  }],
  mounted() {

    const userData = utils.getParameter(this, 'paramData');
    if (typeof userData === 'object' && utils.isEmpty(userData) === false) {
      this.knoxId = userData.knoxId;
      this.epNo = userData.epNo;
      this.emplName = userData.emplName;
      this.companyName = userData.companyName;
      this.deptName = userData.deptName;
      this.selectedCode.COD_IRSD_STT.key = userData.COD_IRSD_STT;
      this.selectedCode.ynAccAvail.key = userData.ynAccAvail;
      this.selectedCode.ynUseSel.key = userData.ynUseSel;

      if (userData.COD_USR_ACO_STT !== undefined) {
        this.selectedCode.COD_USR_ACO_STT.key = userData.COD_USR_ACO_STT;
      } else {
        this.selectedCode.COD_USR_ACO_STT.key = 'ALL';
      }

      if ((utils.isEmpty(this.epNo) === false)
          || (utils.isEmpty(this.emplName) === false)) {
        this.onSearch();
      }
    }
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    onReset() {
      this.$refs.irsdStatus.reset();
      this.$refs.selectACO.reset();
      this.$refs.accAvail.reset();
      this.$refs.useSel.reset();
      this.$refs.selectACO.select('ALL');
      this.knoxId = '';
      this.epNo = '';
      this.emplName = '';
      this.companyName = '';
      this.deptName = '';
      this.selectedCode.COD_IRSD_STT = { label: '', key: '' };
      this.selectedCode.ynAccAvail = { label: '', key: '' };
      this.selectedCode.ynUseSel = { label: '', key: '' };
    },
    onSearch() {
      if ((utils.isEmpty(this.epNo) === true) && (utils.isEmpty(this.emplName) === true)) {
        const message = utils.strFormat(this.$t('MSG_ALT_REQ_INPUT_VAL_2'),
          this.$t('MSG_TXT_EPNO'),
          this.$t('MSG_TXT_EMPL_NM'));
        this.conFirm('warning', message, null);
        return;
      }

      if (utils.isEmpty(this.knoxId) === false) {
        if (this.knoxId.length < 2) {
          this.conFirm('warning', this.$t('MSG_ALT_SRCH_LENG'), null);
          return;
        }
      }

      if (utils.isEmpty(this.epNo) === false) {
        if (this.epNo.length < 2) {
          this.conFirm('warning', this.$t('MSG_ALT_SRCH_LENG'), null);
          return;
        }
      }

      if (utils.isEmpty(this.emplName) === false) {
        if (this.emplName.length < 2) {
          this.conFirm('warning', this.$t('MSG_ALT_SRCH_LENG'), null);
          return;
        }
      }

      const irsdStt = this.selectedCode.COD_IRSD_STT.key === 'ALL' ? '' : this.selectedCode.COD_IRSD_STT.key;
      const accAvail = this.selectedCode.ynAccAvail.key === 'ALL' ? '' : this.selectedCode.ynAccAvail.key;
      const useSel = this.selectedCode.ynUseSel.key === 'ALL' ? '' : this.selectedCode.ynUseSel.key;
      const usrAcoStt = this.selectedCode.COD_USR_ACO_STT.key === 'ALL' ? 'ALL' : this.selectedCode.COD_USR_ACO_STT.key;

      const queryParams = {
        knoxId: this.knoxId || '',
        epNo: this.epNo || '',
        name: this.emplName || '',
        companyName: this.companyName || '',
        deptName: this.deptName || '',
        empStatus: irsdStt || '',
        accAvail: accAvail || '',
        useYn: useSel || '',
        searchUsrAcoStt: usrAcoStt || '',
      };
      http.request(this.$options.name, 'DTS_CMY_00014', {
        query: queryParams,
      }).then(res => {
        this.dsData.setRawData(res.data);
        this.dsData.clearSelection();
      }).catch(error => {
        console.log(error);
      });
    },
    onExcelDownload() {
      const gridData = [];
      utils.forEach(this.dsData.data, item => {
        gridData.push({
          no: item.no,
          knoxId: item.knoxId,
          epno: item.epno,
          usrNameList: item.usrNm,
          usrGlobalNameList: item.usrGlblNm,
          crlvNm: item.crlvNm,
          cpnyNm: item.cpnyNm,
          deptNm: item.deptNm,
          irsdSttNm: item.irsdSttNm,
          accountUseYn: item.accountUseYn,
          usrAccountStatusNm: item.usrAccountStatusNm,
          usrRealUseYnNm: item.usrRealUseYnNm,
        });
      });

      const sToday = utils.now('YYYYMMDDHHmmss');
      const sExcelName = `userMgmt_${sToday}.xlsx`;

      if (gridData.length > 0) {
        utils.downloadDataToExcel(this.$options.name, this.gridColumns, gridData, sExcelName);
      } else {
        this.conFirm('error', this.$t('MSG_ALT_SAV_NO_DATA'), null);
      }
    },
    onItemAdd() {
      this.userComboDisable = false;
      const paramData = {
        knoxId: this.knoxId,
        epNo: this.epNo,
        emplName: this.emplName,
        companyName: this.companyName,
        deptName: this.deptName,
        COD_IRSD_STT: this.selectedCode.COD_IRSD_STT.key,
        COD_USR_ACO_STT: this.selectedCode.COD_USR_ACO_STT.key,
        ynAccAvail: this.selectedCode.ynAccAvail.key,
        ynUseSel: this.selectedCode.ynUseSel.key,
      };
      utils.goPage('PGE_CMY_00023', { status: 'ADD', paramData });
    },
    onUserRegist(btn, dataRow) {
      console.log(btn);
      const paramData = {
        knoxId: this.knoxId,
        epNo: this.epNo,
        emplName: this.emplName,
        companyName: this.companyName,
        deptName: this.deptName,
        COD_IRSD_STT: this.selectedCode.COD_IRSD_STT.key,
        ynAccAvail: this.selectedCode.ynAccAvail.key,
        ynUseSel: this.selectedCode.ynUseSel.key,
        COD_USR_ACO_STT: this.selectedCode.COD_USR_ACO_STT.key,
      };
      this.userComboDisable = true;
      utils.goPage('PGE_CMY_00023', { status: 'MOD', paramData, userData: dataRow });
    },
    onClose() {
      console.log('onClose');
    },
    conFirm(type, value, subValue) {
      utils.messageBox(type, value, subValue, this.onClose);
    },
    onClickAuthCopy() {
      const selectedData = this.dsData.getSelectedRows();
      if (!this.gridSelectedCheck()) return false;
      if (!this.authAdminCheck()) return false;

      utils.messageBox('confirm', this.$t('MSG_ALT_IS_AUTH_CHG'), null, () => {
        http.request(this.$options.name, 'DTS_CMY_00062', {
          path: {
            'user-id': selectedData[0].userId,
          },
        }).then(() => {
          this.logoOff();
        });
      });

      return null;
    },
    onClickAuthDetail() {
      const selectedData = this.dsData.getSelectedRows();
      if (!this.gridSelectedCheck()) return;
      utils.openLayerPopup('PGE_CMA_00016', this.onPagePopupCallback, {
        pageInitialData: {
          userId: selectedData[0].userId,
        },
        size: 'lg',
      });
    },
    gridSelectedCheck() {
      const selectedData = this.dsData.getSelectedRows();

      if (selectedData.length < 1) {
        // 선택 안했을 때
        utils.messageBox('warning', this.$t('MSG_ALT_NOT_SEL_ITEM'));// 선택 된 항목이 없습니다.
        return false;
      }
      if (!utils.isEqual(selectedData[0].accAvail, 'Y')) {
        // 선택 안했을 때
        utils.messageBox('warning', this.$t('MSG_ALT_USR_INFO_NOT_COPY'));// 계정정보를 보유한 사용자만 복사 가능합니다.
        return false;
      }
      return true;
    },
    authAdminCheck() {
      const { roleList } = this.$store.getters.userInfo;

      const adminIndex = utils.findIndex(roleList, o => (utils.isEqual(o.roleNickName, 'ADMIN')));

      if (adminIndex < 0) {
        utils.messageBox('warning', this.$t('MSG_ALT_AUTH_CHG_ADMIN'));

        return false;
      }
      return true;
    },
    logoOff() {
    },
  },
};
</script>
<style scoped>
</style>
